"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
exports.configureFlashMessages = config_1.configureFlashMessages;
exports.getConfig = config_1.getConfig;
var service_1 = require("./service");
exports.addError = service_1.addError;
exports.addWarning = service_1.addWarning;
exports.addSuccess = service_1.addSuccess;
exports.addInfo = service_1.addInfo;
exports.addApocalypse = service_1.addApocalypse;
exports.addFlashMessageOfType = service_1.addFlashMessageOfType;
var flash_message_reducer_1 = require("./flash-message-reducer");
exports.flashMessage = flash_message_reducer_1.flashMessage;
exports.addFlashMessage = flash_message_reducer_1.addFlashMessage;
exports.removeFlashMessage = flash_message_reducer_1.removeFlashMessage;
var models_1 = require("./models");
exports.MessageTypes = models_1.MessageTypes;
